import type { Book } from "../../models/types";
import { STATUS_LABELS } from "../../models/types";
import { renderStars, esc } from "./stars";
import { renderCoverImage } from "./cover-image";

export function renderBookList(books: Book[]): string {
  if (books.length === 0) {
    return `
      <div class="empty-state">
        <div class="empty-state__title">No Books Found</div>
        <div class="empty-state__text">Add a book to get started, or adjust your filters.</div>
      </div>
    `;
  }

  return `
    <div class="book-list">
      ${books.map((book) => renderBookCard(book)).join("")}
    </div>
  `;
}

function formatDateNice(dateStr: string): string {
  const parts = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!parts) return dateStr;
  const d = new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]));
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function renderBookCard(book: Book): string {
  const statusClass = book.status;
  const hasSeries = !!book.series;

  let authorText = esc(book.author);
  if (book.datePublished) authorText += ` · ${esc(book.datePublished)}`;

  const seriesHtml = hasSeries
    ? `<div class="book-card__series">${esc(book.series)}${book.seriesNumber ? ` #${esc(book.seriesNumber)}` : ""}</div>`
    : "";

  const dateReadHtml = book.dateRead
    ? `<span class="book-card__date-read">${formatDateNice(book.dateRead)}</span>`
    : "";

  return `
    <div class="book-card book-card--${statusClass}${hasSeries ? " book-card--has-series" : ""}" data-book-id="${book.id}">
      ${renderCoverImage(book.coverUrl, "small")}
      <div class="book-card__info">
        <div class="book-card__title">${esc(book.title)}</div>
        <div class="book-card__author">${authorText}</div>
        ${seriesHtml}
      </div>
      <div class="book-card__aside">
        <span class="book-card__status book-card__status--${statusClass}">
          ${STATUS_LABELS[book.status]}
        </span>
        ${dateReadHtml}
        ${renderStars(book.rating)}
      </div>
    </div>
  `;
}
